const dnaNameCookie = "DeviceInfo=";

export const setDna = () => {
  if ("AuthfySdk" in window) {
    const sample_collector = () => {
      (window as any).AuthfySdk.init()
        .then((sdk: any) => sdk.getDeviceInfo())
        .then((data: any) => (document.cookie = dnaNameCookie + data))
        .catch((error: any) => console.error(error));
    };
    sample_collector();
  }
};

export const getDna = () => {
  const [, cookieValue] = document.cookie
    .split("; ")
    .find((row) => row.startsWith(dnaNameCookie))
    ?.split("=")!;

  return cookieValue;
};
